/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import { IDescriptorBody } from '../../../descriptor';
import PackageDataMessage, { IPackageDataMessage } from './packagedatamessage';

import ParserUtils, { MessageDataTypes } from './../parserutils';

export interface INumberObjectPacketDataMessage extends IPackageDataMessage {
	data: number;
	data1?: string;
}

export default class NumberObjectPacketDataMessage extends PackageDataMessage {
	public static readonly TYPE: number =
		/* #__PURE__ -- @preserve */ ( () => ParserUtils.getPacketType( MessageDataTypes.NUMBER, MessageDataTypes.OBJECT ) )();

	public static readonly DESCRIPTOR_NAME: string = 'NumberObjectPacketDataMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = /* #__PURE__ -- @preserve */ ( () => ( {
		fields: {
			data: {
				type: 'uint32',
				id: 1
			},
			data1: {
				type: 'string',
				id: 2
			}
		}
	} ) )();

	public constructor( public readonly data: number, public readonly data1: Record<string, unknown> ) {
		super();
	}

	public toJSON(): INumberObjectPacketDataMessage {
		return {
			data: this.data,
			data1: this.data1 ? JSON.stringify( this.data1 ) : undefined
		};
	}

	public static fromJSON( data: INumberObjectPacketDataMessage ): NumberObjectPacketDataMessage {
		return new NumberObjectPacketDataMessage( data.data, data.data1 && JSON.parse( data.data1 ) );
	}

	public static create( data: number, data1: Record<string, unknown> ): NumberObjectPacketDataMessage {
		return new NumberObjectPacketDataMessage( data, data1 );
	}
}
